import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import App from "./App";
import "./index.scss";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initPwaInstallListener } from "./shared/pwa/pwa-install";

initPwaInstallListener();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      {/* short enough not to linger, long enough to read; hovering pauses the
          timer and the close button dismisses it immediately */}
      <ToastContainer autoClose={2000} />
      <App />
    </BrowserRouter>
  </Provider>,
  // </StrictMode>
);

// Register service worker so the app can be installed as a PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
